<div [caLocalizationScope]="localizationScope" class="mb-6">
  <span class="heading-20 d-block mb-2" data-automation-id="saved-filters-title">
    {{ 'savedFiltersTitle' | caLocalize | uppercase }}
  </span>
  <f-single-suggester
    data-automation-id="saved-filters-suggester"
    [placeholder]="'searchSavedFilter' | caLocalize"
    [isOutlineInput]="false"
    [valuePath]="'name'"
    [showPredefinedSet]="true"
    [lazyLoadPredefinedSet]="false"
    [selectedValue]="suggesterStore.selectedFilter()?.['name']?.toString() ?? ''"
    [items]="suggesterStore.savedFiltersSuggestions()"
    [maxResultsCount]="5"
    (reset)="onReset()"
    (select)="onSelect($event)"
  >
    <ng-template #fSuggesterItemTemplate let-item="item" let-inputValue="inputValue">
      <div
        [innerHTML]="item['name'] | fHighlight : inputValue"
        [attr.data-automation-id]="'saved-filter-name-' + item.id"
      ></div>
    </ng-template>
    <ng-template #fNoDataTemplate>
      <span class="text-muted" data-automation-id="no-saved-filters-message">{{
        'noSavedFiltersMessage' | caLocalize
      }}</span>
    </ng-template>
  </f-single-suggester>
</div>
